import { Box, HStack, Image, Text, Icon } from "@chakra-ui/react";
import { FaStar } from "react-icons/fa";

// Google Rating Component
const GoogleRating = () => {
  return (
    <Box
      bg="white"
      p={2}
      borderRadius="md"
      boxShadow="md"
      textAlign="center"
      cursor={"pointer"}
    >
      <Text fontSize={{ base: "sm", md: "md" }} fontWeight="bold" color="blue.600">
        Fixed and Fitted
        {/* <Text as="span" fontWeight="bold" color="gray.500">
          .com
        </Text> */}
      </Text>

      <HStack spacing={1} justify="center" mt={1}>
        <Text fontSize={{ base: "md", md: "lg" }} fontWeight="bold" color="orange.500">
          5.0
        </Text>
        {[...Array(5)].map((_, i) => (
          <Icon key={i} as={FaStar} color="orange.400" boxSize={3} />
        ))}
        <Image src="/images/google.png" alt="Google Logo" boxSize="30px" />
      </HStack>
    </Box>
  );
};

export default GoogleRating;
